import { getCategoryTreeSlug } from '@/integrations/_helpers/getCategoryTreeSlugFromAlgolia'
import { getCategoryTreeFromCrumbs } from '@/integrations/_helpers/getCategoryTreeFromCrumbs'
import {
    getMadeToOrderText,
    getShippingMessage,
    getTimeRemainingText,
    getEddText,
} from '@/helpers/shipping'

export default (ctx) => {
    // NOTE: $geolocation is another integration that loads before this.
    const { $clientCookies, store, $config, $emailTracker, $integrationsManager, $uiEvents } = ctx

    let $cognito
    let $geolocation

    $integrationsManager.onReady((integrations) => {
        $cognito = integrations.cognito
        $geolocation = integrations.geolocation
    })

    $uiEvents.$on('firstLoaded', emitRouteInfo)
    $uiEvents.$on('firstLoaded', emitIdentify)
    $uiEvents.$on('routeChanged', emitRouteInfo)

    // Identify
    $uiEvents.$on('newsletterFormSubmitted', emitFormSubmitted)
    $uiEvents.$on('newsletterSubscribed', emitEmailSubscribed)
    $uiEvents.$on('newsletterUnSubscribed', emitEmailUnSubscribed)

    // Core Logging
    $uiEvents.$on('addToCart', emitAddToCart)
    $uiEvents.$on('removeFromCart', emitRemoveFromCart)
    $uiEvents.$on('promoCodeEntered', emitPromoCodeEntered)
    $uiEvents.$on('promoCodeApplied', emitPromoCodeApplied)
    $uiEvents.$on('promoCodeDenied', emitPromoCodeDenied)
    $uiEvents.$on('promoCodeRemoved', emitPromoCodeRemoved)
    $uiEvents.$on('productListClicked', emitProductListClicked)
    $uiEvents.$on('productListViewed', emitProductListViewed)
    $uiEvents.$on('productListFiltered', emitProductListFiltered)
    $uiEvents.$on('productViewed', emitProductViewed)
    $uiEvents.$on('searched', emitSearched)
    $uiEvents.$on('noSearchResults', emitNoSearchResults)
    $uiEvents.$on('deviceChanged', emitDeviceChanged)
    $uiEvents.$on('selectItemError', emitSelectItemError)

    // FITMENT
    $uiEvents.$on('fitmentChanged', emitFitmentChanged)

    // EXTEND
    $uiEvents.$on('warrantyOfferMade', emitWarrantyOfferMade)
    $uiEvents.$on('warrantyDeclined', emitWarrantyDeclined)
    $uiEvents.$on('viewPlanDetails', emitViewPlanDetails)
    $uiEvents.$on('addWarranty', emitAddWarranty)
    $uiEvents.$on('removeWarranty', emitRemoveWarranty)

    // CMS
    $uiEvents.$on('cmsLinkClicked', emitCmsLinkEvent)

    // A/B TESTS
    $uiEvents.$on('experimentViewed', emitExperimentViewed)

    // CHECKOUT STEPS - Realtruck Flow
    $uiEvents.$on('otherAddressFormViewed', () => emitCheckoutStepOneViewed('Other'))
    $uiEvents.$on('otherAddressFormCompleted', () => emitCheckoutStepOneCompleted('Other'))
    $uiEvents.$on('otherPaymentFormViewed', () => emitCheckoutStepTwoViewed('Other'))
    $uiEvents.$on('otherPaymentFormCompleted', () => emitCheckoutStepTwoCompleted('Other'))
    // CHECKOUT STEPS - Stripe
    $uiEvents.$on('stripePaymentInfoEntered', () => emitPaymentInfoEntered('Stripe', 2))

    // CHECKOUT STEPS - Affirm
    $uiEvents.$on('affirmAddressFormViewed', () => emitCheckoutStepOneViewed('Affirm'))
    $uiEvents.$on('affirmAddressFormCompleted', () => emitCheckoutStepOneCompleted('Affirm'))
    $uiEvents.$on('affirmPaymentModalViewed', () => emitCheckoutStepTwoViewed('Affirm'))
    $uiEvents.$on('affirmPaymentModalCompleted', () => emitCheckoutStepTwoCompleted('Affirm'))
    $uiEvents.$on('affirmPaymentInfoEntered', () => emitPaymentInfoEntered('Affirm', 2))

    // CHECKOUT STEPS - Bolt
    $uiEvents.$on('boltPaymentModalViewed', () => emitCheckoutStepOneViewed('Bolt'))
    $uiEvents.$on('boltPaymentModalCompleted', () => emitCheckoutStepOneCompleted('Bolt'))
    $uiEvents.$on('boltPaymentInfoEntered', () => emitPaymentInfoEntered('Bolt', 1))
    $uiEvents.$on('boltShippingDetailsComplete', emitBoltShippingData)
    $uiEvents.$on('boltEmailSet', (email) => emitIdentify({ email }))
    $uiEvents.$on('boltAbandon', () => track('Bolt Checkout Abandon'))

    // CHECKOUT STEPS - Paylpal
    $uiEvents.$on('paypalPaymentModalViewed', () => emitCheckoutStepOneViewed('Paypal'))
    $uiEvents.$on('paypalPaymentModalCompleted', () => emitCheckoutStepOneCompleted('Paypal'))
    $uiEvents.$on('paypalPaymentInfoEntered', () => emitPaymentInfoEntered('Paypal', 1))

    // THIPAY - Phone Payment Placed
    $uiEvents.$on('phonePaymentPlaced', emitPhonePaymentPlaced)

    $uiEvents.$on('checkoutStarted', emitCheckoutStarted)
    $uiEvents.$on('orderPlaced', emitOrderPlaced)
    $uiEvents.$on('giftCardAdded', emitGiftCardAdded)
    $uiEvents.$on('giftCardDenied', emitGiftCardDenied)
    $uiEvents.$on('giftCardRemoved', emitGiftCardRemoved)

    // Vertibrae
    $uiEvents.$on('segmentEvent', emitSegmentEvent)

    // Log Errors we can track with Segment
    $uiEvents.$on('errorLog', emitErrorLog)

    // MyAccount
    $uiEvents.$on('signUp', emitSignUp)
    $uiEvents.$on('signIn', emitSignIn)

    // Save For Later
    $uiEvents.$on('saveForLaterAdded', emitSaveForLaterAdded)
    $uiEvents.$on('saveForLaterMoved', emitSaveForLaterMoved)
    $uiEvents.$on('saveForLaterDeleted', emitSaveForLaterDeleted)

    // Back In Stock Notifications
    $uiEvents.$on('backInStockSubscribed', emitBackInStockSubscribed)

    // Installernet
    $uiEvents.$on('installernetOffered', emitInstallationOffered)
    $uiEvents.$on('installationAdded', emitInstallationAdded)
    $uiEvents.$on('installationRemoved', emitInstallationRemoved)

    /* eslint-disable */
    // prettier-ignore
    !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.13.1";}}();
    /* eslint-enable */

    $integrationsManager.loaders.onLoadLoader(() => {
        window.analytics?.load($config.runtime.integrations.segment.apiKey)
    })

    // Report Errors to Segment
    // errorType String. Ex: 'no year in fitment'
    function emitErrorLog({ errorType }) {
        track('Error Log', { errorType })
    }

    // Generic Event for one off basic reporting
    function emitSegmentEvent({ category, action, label }) {
        track(action, {
            category,
            action,
            label,
        })
    }

    function emitRouteInfo({ to }) {
        const siteSpect = getSiteSpectsData()
        const geoData = getGeoLocationData()

        window.analytics.page(getPageName(), {
            pageType: getPageType(to.name),
            ...(geoData && geoData),
            ...(siteSpect && siteSpect),
        })
        tryEmitCart(to.name)
    }

    // test CMS pages
    function getPageType(routeName) {
        if (routeName.includes('category')) return 'catPage'
        if (routeName.includes('brand')) return 'brandPage'
        if (routeName.includes('product')) return 'productLinePage'
        if (routeName.includes('specials')) return 'specialsPage'
        if (routeName === 'sku') return 'skuPage'
        if (routeName === 'mmy') return 'vehiclePage'
    }

    // Get Page Name from Title
    function getPageName() {
        const title = document.title
        const cleanTitle = title.replace('| ' + $config.runtime.siteName, '')
        return cleanTitle.trim()
    }

    // emit cart if it's ready (and the right route)
    function tryEmitCart(routeName) {
        if (routeName !== 'cart') return

        // cart is defer loaded, tis not ready yet (really only if cart is your 1st hit)
        if (!store.state.cart.data.items) {
            const unwatch = store.watch(
                (state) => {
                    return state.cart.data
                },
                () => {
                    if (store.state.cart.data.items !== undefined) {
                        emitCart()
                        unwatch()
                    }
                }
            )
        } else emitCart()
    }

    // Log a Client Side $Device category change event
    let isDebounced = false // When going from D-top to Mobile this event will fire for both Small and Mobile.
    function emitDeviceChanged(device) {
        if (isDebounced) return
        isDebounced = true
        const screenDimensions = window.screen
            ? `${window.screen.width}x${window.screen.height}`
            : `${window.innerWidth}x${window.innerHeight}`

        track('Device Changed', {
            changed: `${device.from} -> ${device.to}`,
            device: `${screenDimensions} / ${window.navigator.userAgent}`,
        })
        setTimeout(() => (isDebounced = false), 1000)
    }

    function emitCmsLinkEvent(obj) {
        track('Clicked', obj)
    }

    // Emit when a USER changes fitment (ignore auto-fill)
    const primaryFitment = getFitment()
    function emitFitmentChanged({ sourceType, newValue }) {
        const type = sourceType.replace('Slug', '') // Cleanup type passed by Drills
        const value = typeof newValue === 'number' ? newValue.toString() : newValue // Convert number values to string
        track(`Fitment: Selected: ${type}`, {
            [type]: value,
        })

        // store ymm in a variable to send to segment when model is selected
        if (type === 'year' || type === 'make' || type === 'model') primaryFitment[type] = value

        // send ymm to segment when model is selected
        if (type === 'model') {
            emitPrimaryFitment(primaryFitment)
            // also send primary fitment as user trait
            emitIdentifyFitment(primaryFitment)
        }
    }

    function emitPrimaryFitment(fitment) {
        track('Fitment: Selected: Primary YMM', fitment)
    }

    // Emit when a USER views the A/B test they are apart of
    function emitExperimentViewed(exp) {
        track('Experiment Viewed', {
            exp,
        })
    }

    function emitCart() {
        track('Cart Viewed', {
            cart_id: store.state.permId,
            products: getCartProducts(store.state.cart.data.items),
        })
    }

    // loops through an array of cart products and returns them
    function getCartProducts(products) {
        return products.map((product, index) => {
            const cartProduct = getCartProduct(product, index + 1)
            if (product.warranty) cartProduct.warranty = getWarrantyInfo(product.warranty)
            return cartProduct
        })
    }

    // returns our standard product obj from a cart obj
    function getCartProduct(product, position = 1) {
        const isQuickshipable = isQuickship(product.shipping)
        const { eddMessage, eddMin, eddMax } = estimatedDelivery(product.shipping)
        const expectedDate = product?.shipping?.expected || null
        const primaryFitment = getFitment()

        const obj = {
            name: product.productName,
            sku: product.sku,
            position,
            quantity: product.qty,
            category: product.category,
            // brand
            price: product.salePrice / 100,
            product_id: product.productSlug, // cart also has skuSlug, but receipt obj does not :(
            ...(isQuickshipable && { quickship: isQuickshipable }),
            ...(eddMessage && { edd_message: eddMessage }),
            ...(eddMin && { edd_min: eddMin }),
            ...(eddMax && { edd_max: eddMax }),
            ...(expectedDate && { expected_date: expectedDate }),
            ...(primaryFitment && primaryFitment),
            ...(product.installation?.subtotal && {
                installation_price: product.installation.subtotal,
            }),
        }

        if (product.productLineSlug)
            obj.url = `https://${$config.runtime.domain}/p/${product.productLineSlug}/${product.productSlug}/`

        return obj
    }

    function emitAddToCart(lastItem) {
        if (!lastItem) return
        const product = getCartProduct(lastItem)
        track('Product Added', { cart_id: store.state.permId, ...product })
    }

    function emitRemoveFromCart(lastItem) {
        if (!lastItem) return
        const product = getCartProduct(lastItem)
        track('Product Removed', { cart_id: store.state.permId, ...product })
    }

    function emitPromoCodeEntered(code) {
        track('Coupon Entered', {
            cart_id: store.state.permId,
            coupon_id: code,
            // order_id
        })
    }

    function emitPromoCodeApplied(code) {
        track('Coupon Applied', {
            cart_id: store.state.permId,
            coupon_id: code,
            // order_id
            // discount
            // coupon_name
        })
    }

    function emitPromoCodeDenied(code) {
        track('Coupon Denied', {
            cart_id: store.state.permId,
            coupon_id: code,
            // order_id
            // reason
        })
    }

    function emitPromoCodeRemoved(code) {
        track('Coupon Removed', {
            cart_id: store.state.permId,
            coupon_id: code,
            // order_id
            // discount
            // coupon_name
        })
    }

    function getAlgoliaProducts(algoliaObjs, useProductLineSlug = false) {
        return algoliaObjs.map((product, index) => {
            return getAlgoliaProduct(product, index + 1, useProductLineSlug)
        })
    }

    function getAlgoliaProduct(product, position = 1, useProductLineSlug = false) {
        const isQuickshipable = isQuickship(product)
        const primaryFitment = getFitment()
        return {
            product_id: useProductLineSlug ? product.productLineSlug : product.productId,
            sku: product.skuSlug,
            category: getCategoryTreeSlug(product.categories),
            name: product.productLineName,
            brand: product.brandSlug,
            price: product.salePrice / 100,
            quantity: 1,
            position,
            ...(isQuickshipable && { quickship: isQuickshipable }),
            ...(primaryFitment && primaryFitment),
        }
    }

    function emitProductListClicked({ algoliaObj, position, location }) {
        track('Product Clicked', getAlgoliaProduct(algoliaObj))
    }

    // when a product square is viewed (currently just the whole result, not on viewport)
    function emitProductListViewed(algoliaObjs) {
        track('Product List Viewed', {
            list_id: 'main',
            // category - We get individual products, but no main category to put here
            products: getAlgoliaProducts(algoliaObjs),
        })
    }

    function emitProductListFiltered({ filters, sort, products }) {
        // Determine Filters
        const filterObj = Object.keys(filters).reduce((acc, attributeName) => {
            const values = filters[attributeName].map((attribute) => ({
                type: attributeName,
                value: attribute.value,
            }))
            acc.push(...values)
            return acc
        }, [])

        // Determine Sort from indexName
        let sortType = null
        let sortDirection = null
        if (sort) {
            sortType = sort.includes('price') ? 'price' : 'recommended'
            if (sort.includes('_desc')) sortDirection = 'desc'
            else if (sort.includes('_asc')) sortDirection = 'asc'
        }

        track('Product List Filtered', {
            list_id: 'main',
            filters: filterObj,
            ...(sort && {
                sorts: [
                    {
                        type: sortType,
                        value: sortDirection,
                    },
                ],
            }),
            products: getAlgoliaProducts(products),
        })
    }

    function emitSearched({ isSubmitted, query }) {
        track('Products Searched', {
            query: query.toLowerCase(),
        })
    }

    function emitNoSearchResults(query) {
        track('Search - No Results', {
            emptySearchTerm: query.toLowerCase(),
        })
    }

    // Installernet Events
    function emitInstallationAdded(lastItem) {
        if (!lastItem) return
        // Format the product data
        const productData = getCartProduct(lastItem)
        track('Installation Added', { cart_id: store.state.permId, ...productData })
    }

    function emitInstallationRemoved(item) {
        if (!item) return
        // Format the product data
        const productData = getCartProduct(item)
        track('Installation Removed', { cart_id: store.state.permId, ...productData })
    }

    function emitInstallationOffered(product) {
        if (!product) return
        track('Installation Offered', _formatProductData(product))
    }

    function emitProductViewed({ location, index }) {
        const product =
            location === 'main'
                ? store.state.product.data
                : store.state.product.controls.groups[index].product

        if (!product) return
        track('Product Viewed', _formatProductData(product))

        emitProductShipping(product)
    }

    function _formatProductData(product) {
        const isQuickshipable = isQuickship(product.shipping)
        const { eddMessage, eddMin, eddMax } = estimatedDelivery(product.shipping)
        const primaryFitment = getFitment()

        return {
            ...(product.sku && { sku: product.sku }),
            ...(product.skuSlug && { product_id: product.skuSlug }),
            category: getCategoryTreeFromCrumbs(product.crumbs).slugs.join('/'),
            name: product.name,
            brand: product.brand.name,
            ...(product.actualPrice && { price: product.actualPrice.min / 100 }),
            quantity: 1,
            currency: 'usd',
            ...(product.actualPrice && { value: product.actualPrice.min / 100 }), // Total value of the product after quantity
            ...(isQuickshipable && { quickship: isQuickshipable }),
            ...(eddMessage && { edd_message: eddMessage }),
            ...(eddMin && { edd_min: eddMin }),
            ...(eddMax && { edd_max: eddMax }),
            ...(primaryFitment && primaryFitment),
        }
    }

    function emitProductShipping(product) {
        if (!product.shipping) return

        let sameDayObj = {}
        if (product.shipping.sameDay) {
            sameDayObj = getTimeRemainingText(
                product.shipping.sameDay.startDayOfWeek,
                product.shipping.sameDay.endDayOfWeek,
                product.shipping.sameDay.cutoffTime,
                !!product.shipping.estimatedDeliveryDate
            )
        }

        let madeToOrderText = ''
        if (product.shipping.estimated || product.isMadeToOrder) {
            const text = getMadeToOrderText(product.isMadeToOrder, product.shipping.estimated)
            madeToOrderText = `${text.main || ''} ${text.shipTime || ''}`.trim()
        }

        track('Customer Shipping Expectations', {
            ...(product.sku && { sku: product.sku, label: product.sku }),
            product: product.name,
            ...(product.actualPrice && { price: product.actualPrice.min / 100 }),
            brand: product.brand.name,
            product_category: getCategoryTreeFromCrumbs(product.crumbs).slugs.join('/'),
            ...(product.shipping.sameDay && { shipping_same_day_object: sameDayObj }),
            ...(product.shipping.sameDay &&
                sameDayObj.orderText && { shipping_same_day_message: sameDayObj.orderText }),
            ...(madeToOrderText && { made_to_order: madeToOrderText }),
            ...(product.shipping && { shipping_text: getShippingMessage(product.shipping) }),
            category: 'Customer Messages',
            action: 'Customer Shipping Expectations',
        })
    }

    function emitSelectItemError({ type, error, extra }) {
        error = typeof error === 'undefined' ? {} : error
        extra = typeof extra === 'undefined' ? {} : extra

        const event = Object.assign(
            {
                type, // NETWORK_ERROR, UNEXPECTED_RESULT, UKNOWN
                ...(error.config && { url: error.config.url }),
                ...(error.config && { requestData: error.config.data }),
                ...(error.response && { status: error.response.status }),
                ...(error.response && { errors: error.response.data.errors }),
            },
            extra
        )

        track('Select Item Error', event)
    }

    function emitCheckoutStarted(paymentType) {
        const checkoutData = store.state.checkout.data
        const summary = checkoutData.summary

        track('Payment Type Selected', {
            checkout_id: checkoutData.id,
            payment_method: paymentType,
        })

        track('Checkout Started', {
            value: summary.grandTotal / 100, // Revenue ($) with discounts and coupons added in.
            revenue: summary.cartSubtotal / 100, // Revenue ($) associated with the transaction (excluding shipping and tax)
            shipping: summary.shippingSubtotal,
            tax: summary.taxSubtotal,
            // discount: 2.5,
            // coupon: 'hasbros',
            currency: 'USD',
            products: getCartProducts(store.state.cart.data.items),
        })
    }

    // Steps
    // Bolt -> Modal Shown -> Order Placed
    // Paypal -> New Page -> Order Placed
    // Affirm -> Address -> Modal -> Order Placed
    function emitCheckoutStepOneViewed(paymentMethod) {
        track('Checkout Step Viewed', {
            checkout_id: store.state.checkout.data.checkout_id,
            step: 1,
            payment_method: paymentMethod,
        })
    }

    function emitCheckoutStepOneCompleted(paymentMethod) {
        track('Checkout Step Completed', {
            checkout_id: store.state.checkout.data.checkout_id,
            step: 1,
            payment_method: paymentMethod,
        })
    }

    function emitCheckoutStepTwoViewed(paymentMethod) {
        track('Checkout Step Viewed', {
            checkout_id: store.state.checkout.data.checkout_id,
            step: 2,
            payment_method: paymentMethod,
        })
    }

    function emitCheckoutStepTwoCompleted(paymentMethod) {
        track('Checkout Step Completed', {
            checkout_id: store.state.checkout.data.checkout_id,
            step: 2,
            payment_method: paymentMethod,
        })
    }

    function emitPaymentInfoEntered(paymentMethod, step) {
        track('Payment Info Entered', {
            checkout_id: store.state.checkout.data.checkout_id,
            step,
            payment_method: paymentMethod,
        })
    }

    function emitPhonePaymentPlaced(data) {
        // We do not know their email currently but segment can match by Phone
        const identity = {
            phone: data.shippingAddress.phone,
            address: data.shippingAddress,
        }
        emitIdentify(identity)

        track('Phone Order Completed', {
            sales_channel_name: data.salesChannelName,
            sales_rep_first_name: data.salesRepFirstName,
            order_number: data.orderNumber,
            total: data.orderTotal / 100,
            subtotal: data.orderSubtotal / 100,
            amount_paid: data.amountPaid / 100,
            amount_remaining: data.amountRemaining / 100,
            shipping: data.orderShippingCost / 100,
            tax: data.orderTax / 100,
            shippingAddress: data.shippingAddress,
            payment_complete: data.paymentComplete,
            currency: 'USD',
        })
    }

    function emitBoltShippingData(address) {
        const identity = {
            email: address.email,
            name: `${address.first_name} ${address.last_name}`,
            phone: address.phone,
            address: {
                address1: address.street_address1,
                address2: address.street_address2,
                city: address.locality,
                stateId: address.region,
                company: address.company,
                zipcode: address.postal_code,
            },
        }
        emitIdentify(identity)
    }

    async function emitOrderPlaced(receiptObj) {
        // emitIdentify based on Shipping Address
        const shippingAddress = receiptObj.shippingContact
        const identity = {
            email: shippingAddress.email,
            name: shippingAddress.fullName,
            phone: shippingAddress.phone,
            address: shippingAddress,
        }

        // =========================
        // Unique to this flow, if we don't have a user id
        // we want to try to create one by secretly making the user
        // an account. We do not want to sign them in, just create the account
        // and snag the userId generated so we can Identify them.
        let userId = await getUserId()
        if (!userId && $cognito.enabled) userId = await $cognito.generateUserId(identity.email)

        // If we have a user id,  add it to the identity object
        if (userId) identity.userId = userId
        // =========================

        emitIdentify(identity)

        const subscribe =
            typeof $clientCookies.getJSON('checkoutSubscribe') === 'undefined'
                ? false
                : $clientCookies.getJSON('checkoutSubscribe')
        $clientCookies.remove('checkoutSubscribe')

        // subscribe them via segment event
        if (subscribe)
            emitEmailSubscribed({
                formName: 'order-placed-subscribe',
                email: shippingAddress.email,
            })

        trackOrderCompleted(receiptObj)
        trackAttribution(receiptObj)
    }

    function trackAttribution(receiptObj) {
        const shippingAddress = receiptObj.shippingContact
        const [first, last] = shippingAddress.fullName.split(' ')
        const fbp = $clientCookies.getJSON('_fbp')
        const fbc = $clientCookies.getJSON('_fbc')
        const iterableTemplateId = $clientCookies.getJSON('iterableTemplateId')
        const iterableEmailCampaignId = $clientCookies.getJSON('iterableEmailCampaignId')
        const iterableMessageId = $clientCookies.getJSON('iterableMessageId')
        const iterableEndUserId = $clientCookies.getJSON('iterableEndUserId')

        track('Attribution Order Revenue', {
            currency: 'USD',
            email: shippingAddress.email,
            phone: shippingAddress.phone,
            firstName: first,
            lastName: last,
            address: shippingAddress.address1,
            city: shippingAddress.city,
            state: shippingAddress.stateId,
            zip: shippingAddress.zipcode,
            orderId: receiptObj.orderId,
            revenue: receiptObj.summary.cartSubtotal / 100,
            shipping: receiptObj.summary.shippingSubtotal / 100,
            subtotal: receiptObj.summary.cartSubtotal / 100,
            tax: receiptObj.summary.taxSubtotal / 100,
            total: receiptObj.summary.grandTotal / 100,
            products: getCartProducts(receiptObj.items),
            ...($geolocation?.enabled &&
                $geolocation.zipcode && { geoPostalCode: $geolocation.zipcode }),
            ...(fbp && { fbp }),
            ...(fbc && { fbc }),
            ...(iterableTemplateId && { iterableTemplateId }),
            ...(iterableEmailCampaignId && { iterableEmailCampaignId }),
            ...(iterableMessageId && { iterableMessageId }),
            ...(iterableEndUserId && { iterableEndUserId }),
        })
    }

    function trackOrderCompleted(receiptObj) {
        const iterableTemplateId = $clientCookies.getJSON('iterableTemplateId')
        const iterableEmailCampaignId = $clientCookies.getJSON('iterableEmailCampaignId')
        const iterableMessageId = $clientCookies.getJSON('iterableMessageId')
        const iterableEndUserId = $clientCookies.getJSON('iterableEndUserId')

        track('Order Completed', {
            order_id: receiptObj.orderId,
            total: receiptObj.summary.grandTotal / 100, // Revenue ($) with discounts and coupons added in.
            subtotal: receiptObj.summary.cartSubtotal / 100, // Order total after discounts but before taxes and shipping
            revenue: receiptObj.summary.cartSubtotal / 100, // Revenue ($) associated with the transaction (excluding shipping and tax)
            shipping: receiptObj.summary.shippingSubtotal / 100,
            tax: receiptObj.summary.taxSubtotal / 100,
            // discount: 2.5,
            // coupon: 'hasbros',
            currency: 'USD',
            products: getCartProducts(receiptObj.items),
            ...(iterableTemplateId && { iterableTemplateId }),
            ...(iterableEmailCampaignId && { iterableEmailCampaignId }),
            ...(iterableMessageId && { iterableMessageId }),
            ...(iterableEndUserId && { iterableEndUserId }),
        })
    }

    function emitGiftCardAdded() {
        track('Gift Card Added', {})
    }

    function emitGiftCardRemoved() {
        track('Gift Card Removed', {})
    }

    function emitGiftCardDenied() {
        track('Gift Card Denied', {})
    }

    function emitEmailUnSubscribed(data) {
        // Identify the user as normal
        emitIdentify(data)
        track('Email UnSubscribed', {})
    }
    function emitEmailSubscribed(data) {
        // As the user has opted in we should store the Email
        $emailTracker.setEmail(data.email)
        // Identify the user as normal
        emitIdentify(data)
        track('Email Subscribed', data)
    }

    /**
     * @param {*} data Should contain all form data plus the formName
     */
    function emitFormSubmitted(data) {
        // one event, form submitted - prop the name
        track('Form Submitted', data)
    }

    function emitWarrantyOfferMade({ warranty, product }) {
        const id = product?.id || ''
        const productObj = getCartProduct(product, id)
        productObj.warranty = getWarrantyInfo(warranty)

        track('Warranty: Offer Made', productObj)
    }

    function emitWarrantyDeclined({ warranty, product }) {
        const id = product?.id || ''
        const productObj = getCartProduct(product, id)
        productObj.warranty = getWarrantyInfo(warranty)

        track('Warranty: Declined', productObj)
    }

    function emitViewPlanDetails({ warranty, product }) {
        const id = product?.id || ''
        const productObj = getCartProduct(product, id)
        productObj.warranty = getWarrantyInfo(warranty)

        track('Warranty: Viewed Plan Details', productObj)
    }

    function emitAddWarranty({ warranty, product }) {
        const id = product?.id || ''
        const productObj = getCartProduct(product, id)
        productObj.warranty = getWarrantyInfo(warranty)

        track('Warranty: Added', productObj)
    }

    function emitRemoveWarranty({ warranty, product }) {
        const id = product?.id || ''
        const productObj = getCartProduct(product, id)
        productObj.warranty = {
            sku: warranty.sku,
            price: warranty.salePrice / 100,
        }
        track('Warranty: Removed', productObj)
    }

    function emitSignUp() {
        emitIdentify()
        track('Account Sign Up', {})
    }

    function emitSignIn() {
        emitIdentify()
        track('Account Sign In', {})
    }

    function emitBackInStockSubscribed({ skuSlug, email }) {
        const primaryFitment = getFitment()

        track('Back In Stock', {
            skuSlug,
            email,
            primaryFitment,
        })
    }

    async function emitSaveForLaterAdded(item) {
        const wishlistID = await store.dispatch('cart/getWishlistId')

        track('Save For Later Added', {
            wishlistID,
            item: formatWishlistItem(item),
        })
    }

    async function emitSaveForLaterMoved(item) {
        const wishlistID = await store.dispatch('cart/getWishlistId')

        track('Save For Later Moved', {
            wishlistID,
            item: formatWishlistItem(item),
        })
    }

    async function emitSaveForLaterDeleted(item) {
        const wishlistID = await store.dispatch('cart/getWishlistId')

        track('Save For Later Deleted', {
            wishlistID,
            item: formatWishlistItem(item),
        })
    }

    // item should always be populated but in the case it isn't for whatever reason, we'll default to an empty obj
    function formatWishlistItem(item = {}) {
        const { image, ...formattedItem } = item

        return formattedItem
    }

    function getWarrantyInfo(warranty) {
        const warrantyArray = Array.isArray(warranty) ? warranty : [warranty]
        return warrantyArray.map((plan) => {
            return {
                sku: plan.id,
                price: plan.price / 100,
            }
        })
    }

    async function emitIdentifyFitment(fitment) {
        // We do not want to fire an identify event without a UserId.
        // We are no longer supporting Anonymous IDs
        // Per Chris Wall: We are no longer identifying people unless we know them
        const userId = await getUserId()
        if (!userId) return

        const siteSpect = getSiteSpectsData()
        const geoData = getGeoLocationData()
        window.analytics.identify(userId, {
            year: fitment.year,
            make: fitment.make,
            model: fitment.model,
            ...(store.state.globalId && { global_id: store.state.globalId }),
            ...(geoData && geoData),
            ...(siteSpect && siteSpect),
        })
    }

    async function emitIdentify(data = {}) {
        // We do not want to fire an identify event without a UserId.
        // We are no longer supporting Anonymous IDs
        // Per Chris Wall: We are no longer identifying people unless we know them
        let { email, userId } = data
        // If they did not give us a UserId, fetch it
        if (!userId) userId = await getUserId()

        // If we STILL do not have a userId, jump ship
        // Note: this means any sight without Cognito enabled will never run Identify
        // Chris Wall is aware of this issue.
        if (!userId) return

        // If they didn't specify an email, fetch it
        if (!email) email = $emailTracker.getEmail()

        // Pull out the rest of the data
        const { name = null, phone = null, address = {} } = data

        // Format the Addreess
        let street = address.address1 || null
        if (street && address.address2) street += ' ' + address.address2
        const addressObj = address.zipcode
            ? {
                  country: address.country || null,
                  street,
                  state: address.stateId || null,
                  city: address.city || null,
                  postalCode: address.zipcode || null,
              }
            : null
        // Layer In GeoLocationData
        const geoData = getGeoLocationData()
        // Layer In SiteSpect Data
        const siteSpect = getSiteSpectsData()
        // Leave out any data we don't have
        const identity = {
            ...(email && { id: email, email }),
            ...(name && { name }),
            ...(phone && { phone }),
            ...(addressObj && { address: addressObj }),
            ...(store.state.globalId && { global_id: store.state.globalId }),
            ...(store.state.permId && { cart_id: store.state.permId }),
            ...(geoData && geoData),
            ...(siteSpect && siteSpect),
        }
        window.analytics.identify(userId, identity)
    }

    // Wrapper around analytics.track for adding in global data such as Email
    async function track(name, data) {
        const email = $emailTracker.getEmail()
        if (email) data = Object.assign({ email }, data)

        // Layer in GeoLocationData
        const geoData = getGeoLocationData()
        if (geoData) data = Object.assign(geoData, data)

        // Layer In SiteSpect Data
        const siteSpect = getSiteSpectsData()
        if (siteSpect) data = Object.assign(siteSpect, data)

        // if userId comes back as non-null then the user
        // is signed in
        const userId = await getUserId()
        if (userId) data = Object.assign({ userId }, data)

        window.analytics.track(name, data)
    }

    function getSiteSpectsData() {
        if (!window.ssWattsCampaignCounted && !window.ssWattsUserVisitCount && !window.ssGuid)
            return null

        return {
            ...(window.ssWattsCampaignCounted && {
                ssWattsCampaignCounted: window.ssWattsCampaignCounted,
            }),
            ...(window.ssWattsUserVisitCount && {
                ssWattsUserVisitCount: window.ssWattsUserVisitCount,
            }),
            ...(window.ssGuid && { ssGuid: window.ssGuid }),
        }
    }

    function isQuickship(shippingData) {
        if (!$config.runtime.theme.sameDayShipping.enabled || !shippingData) return null
        return !!shippingData.sameDay || shippingData.sameDayShipping
    }

    function estimatedDelivery(shippingData) {
        // Estimated Delivery Details
        let eddMessage = null
        let eddMin = null
        let eddMax = null
        // Early out if shippingData undefined
        if (!shippingData) return { eddMessage, eddMin, eddMax }

        if (shippingData.estimatedDeliveryDate) {
            eddMessage = getEddText(shippingData, true)
            eddMin = shippingData.estimatedDeliveryDate.min
            eddMax = shippingData.estimatedDeliveryDate.max
        }
        return { eddMessage, eddMin, eddMax }
    }

    // This is only used by the smsSubscription method in
    // /pages/checkout/receipt/index.vue
    function getAnonId() {
        // Bugsnag caught instances where we called this too soon and .user() was not a function.
        // Specifically in emitIdentifyFitment()
        if (typeof window.analytics.user !== 'function') return null
        return window.analytics.user().anonymousId()
    }

    // This will get the user id of the currently logged in user, if a user is logged in
    async function getUserId() {
        if ($cognito?.enabled) {
            return await $cognito.getUserId()
        }

        return null
    }

    function getFitment() {
        return {
            year: store.state.fitment.data.year,
            make: store.state.fitment.data.make,
            model: store.state.fitment.data.model,
        }
    }

    function getGeoLocationData() {
        if (!$geolocation?.enabled) return null

        return {
            edgePostalCode: $geolocation.edgePostalCode,
            userPostalCode: $geolocation.userPostalCode,
        }
    }

    return { getAnonId }
}
